import { Divider } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Box, Button, Flex, Modal, Typography } from '@percent/lemonade'
import type { UseModalReturn } from '@percent/domain/giving'
import { goodstackPalette } from '@percent/cause-dashboard/theme/theme'

export type CancellationModalProps = Pick<UseModalReturn, 'isOpen' | 'closeModal'> & { description: string }

export function CancellationModal({ isOpen, closeModal, description }: Readonly<CancellationModalProps>) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Modal borderRadiiSize="xlarge" onClose={closeModal} open={isOpen}>
      <Box style={{ padding: '1.5rem' }}>
        <Typography style={{ fontSize: '1.25rem', lineHeight: '1.875rem', fontWeight: '600' }}>
          {t('volunteering.opportunity.form.common.confirmCancellationModal.title')}
        </Typography>
        <Divider my={16} />
        <Typography
          style={{
            fontSize: '0.875rem',
            color: goodstackPalette.neutral300
          }}
        >
          {description}
        </Typography>
        <Flex mt="2rem" gap="1rem" justify="flex-end">
          <Button variant="secondary" onClick={closeModal}>
            {t('volunteering.opportunity.form.common.confirmCancellationModal.continueEditingBtn')}
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              closeModal()
              navigate(-1)
            }}
          >
            {t('button.confirm')}
          </Button>
        </Flex>
      </Box>
    </Modal>
  )
}
